<template>
	<div>
		<div class="table-responsive" v-if="tableData.COURSES_NOT_IN_PROGRESS.length > 0">
			<table-editable-list :columns="departmentColumnsConfig" :show-select="false" :show-actions="false">
				<template slot="data-row">
					<template v-for="(course, courseIdx) in tableData.COURSES_NOT_IN_PROGRESS">
						<table-list-row :key="`course_not_in_progress_${course.COURSE_ID}_${courseIdx}`"
														:columns="departmentColumnsConfig"
														:rowdata="course"
														:rowIndex="courseIdx"
														:showActions="false">
						</table-list-row>
					</template>
				</template>
			</table-editable-list>
		</div>
		<template v-if="tableData.COURSES_IN_PROGRESS.length > 0">
			<div tabindex="0">
				<i>{{ $t('MAIN_CONTENT.ProgressReportDepartments.inProgress') }}</i>
			</div>
			<div class="table-responsive">
				<table-editable-list :columns="departmentColumnsConfig" :show-select="false" :show-actions="false">
					<template slot="data-row">
						<template v-for="(course, courseIdx) in tableData.COURSES_IN_PROGRESS">
							<table-list-row :key="`course_in_progress-${course.COURSE_ID}_${courseIdx}`"
															:columns="departmentColumnsConfig"
															:rowdata="course"
															:rowIndex="courseIdx"
															:showActions="false">
							</table-list-row>
						</template>
					</template>
				</table-editable-list>
			</div>
		</template>
		<template v-if="tableData.COURSES_NOT_IN_PROGRESS.length === 0 && tableData.COURSES_IN_PROGRESS.length === 0">
			<div class="row" tabindex="0">
				<div class="col-xs-12">
					{{ $t('MAIN_CONTENT.ProgressReportDepartments.noCoursesQualifyRequirementWithPeriod') }}
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	import TableEditableList from 'COMMONS/tables/TableEditableList.vue';
	import TableListRow from 'COMMONS/tables/TableListRow.vue';

	export default {
		name: 'ProgressReportDepartments',
		props: {
			departmentColumnsConfig: {
				type: Array,
				required: true
			},
			tableData: {
				type: Object,
				required: true
			}
		},
		components: {
			TableEditableList,
			TableListRow
		}
	}
</script>
